module.exports = __webpack_public_path__ + "static/img/pin-trap-scheduled-mandatory.a694d6f.svg";